const ACTION_TYPES = {
    SET_COMPARE_MODE: 'SET_COMPARE_MODE',
    SET_SELECTED_PRODUCTS: 'SET_SELECTED_PRODUCTS'
};

const initialState = {
    isCompareModeEnabled: false,
    selectedProducts: []
};

const reducer = function (state = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.SET_COMPARE_MODE:
            return {
                ...state,
                isCompareModeEnabled: action.payload,
                // Clear products when disabling compare mode
                selectedProducts: action.payload ? state.selectedProducts : []
            };

        case ACTION_TYPES.SET_SELECTED_PRODUCTS:
            return {
                ...state,
                selectedProducts: action.payload
            };

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

export default reducer;
